<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Add Old User Data
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-menu
                v-model="date_picker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.date"
                    label="Date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                    :error-messages="errors.date"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date"
                  @input="date_picker = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.user_name"
                outlined
                label="User Name"
                prepend-inner-icon="mdi-account"
                :error-messages="errors.user_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"
                maxlength="10"
                @keypress="onlyNumbers"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.invoice_no"
                outlined
                label="Invoice No."
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.invoice_no"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="product"
                outlined
                v-model="form.product"
                :items="productItems"
                label="Product"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.product"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.hsn_sac"
                outlined
                label="HSN/SAC"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.hsn_sac"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.quantity"
                outlined
                label="Quantity"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.quantity"
                @keypress="onlyNumbers"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="product"
                outlined
                v-model="form.unit"
                :items="productUnitItems"
                label="Unit"
                prepend-inner-icon="mdi-card-text-outline"
                clearable
                :error-messages="errors.unit"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.price_per_unit"
                outlined
                label="Price Per Unit"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.price_per_unit"
                @keypress="onlyNumbers"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.discount"
                outlined
                label="Discount"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.discount"
                @keypress="onlyNumbers"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.gst"
                outlined
                label="GST Pecentage"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.gst"
                @keypress="onlyNumbers"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.amount"
                outlined
                label="Amount"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.amount"
                @keypress="onlyNumbers"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Old User Data
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "OldUserDataCreatePage",
  data() {
    return {
      form: {
        name: "",
        date: "",
      },
      productItems: [],
      productUnitItems: [],
      isLoading: false,
      date_picker: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`old_user_datas/masters`)
        .then((masters) => {
          masters = masters.data;
          // Products
          masters.products.forEach((product) => {
            this.productItems.push({
              id: product.id,
              text: product.name,
              value: product.name,
            });
          });
          // Product Units
          masters.product_units.forEach((product_unit) => {
            this.productUnitItems.push({
              id: product_unit.id,
              text: product_unit.description,
              value: this.pascalCaseText(product_unit.description),
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/old_user_datas", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.back();
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
